import Homepage from "../components/Homepage.vue"

import Vignette from "../components/Vignette.vue"
import Toll from '../components/Toll.vue'

import TollCategory from '../components/TollCategory.vue'
import VignetteCategory from '../components/VignetteCategory.vue'

import Cart from '../components/order/Cart.vue'

import OrderContainer from '../components/order/OrderContainer.vue'
import Billing from '../components/order/Billing.vue'
import PaymentMethod from '../components/order/PaymentMethod.vue'
import ThankYou from '../components/order/ThankYou.vue'

import Login from '../components/authentication/Login.vue'
import NewAccount from '../components/authentication/NewAccount.vue'
import ResetPassword from '../components/authentication/ResetPassword.vue'
import ResetPasswordUpdate from '../components/authentication/ResetPasswordUpdate.vue'

import AccountContainer from '../components/account/AccountContainer.vue'
import AccountData from '../components/account/AccountData.vue'
import MyCars from '../components/account/MyCars.vue'
import MyOrders from '../components/account/MyOrders.vue'
import Order from '../components/account/Order.vue'
import Profiles from '../components/account/Profiles.vue'
import Cards from '../components/account/Cards.vue'

import AddCar from '../components/account/AddCar.vue'
import EditCar from '../components/account/EditCar.vue'

import AddProfile from '../components/account/AddProfile.vue'
import EditProfile from '../components/account/EditProfile.vue'

import HowItWorks from '../components/HowItWorks.vue'
import Distribution from '../components/Distribution.vue'
import Info from '../components/Info.vue'
import AboutErov from "../components/AboutErov.vue"
import AboutPeaj from "../components/AboutPeaj.vue"
import AboutUs from "../components/AboutUs.vue"
import Contact from '../components/Contact.vue'
import FrequentQuestions from '../components/FrequentQuestions.vue'
import Cookies from '../components/Cookies.vue'
import Terms from '../components/Terms.vue'
import Confidentiality from '../components/Confidentiality.vue'
import Partners from '../components/Partners.vue'

import AccountActivate from '../components/account/AccountActivate.vue'

import ResetCart from "../components/ResetCart.vue"
import LogByUser from "../components/LogByUser.vue"

import BenefitsLadingPage from "../components/BenefitsLadingPage.vue"

const routes = [
    { path: '/', name: 'homepage', component: Homepage, meta: {title: 'UNTRR'} },
    { path: '/reset-cart', name: 'reset-cart', component: ResetCart, meta: {title: 'UNTRR'} },
    { path: '/log-by-user/:id/:hash', name: 'log-by-user', component: LogByUser, meta: {title: 'UNTRR'}, props: true },
    { path: '/e-rovinieta', name: 'vignette', component: Vignette, meta: {title: 'E-rovinieta'} },
    { path: '/taxa-pod-fetesti', name: 'toll', component: Toll, meta: {title: 'Taxa pod Fetesti'} },

    { path: '/cum-functioneaza', name: 'how-it-works', component: HowItWorks },
    { path: '/puncte-distributie', name: 'distribution', component: Distribution },
    { path: '/info-legislative', name: 'info', component: Info },

    { path: '/peaj/:id/:carId?', name: 'toll-category', component: TollCategory, props: true },
    { path: '/rovinieta/:id/:carId?', name: 'vignette-category', component: VignetteCategory, props: true },

    { path: '/login/:from?', name: 'login', component: Login },
    { path: '/cont-nou', name: 'new-account', component: NewAccount },

    { path: '/despre-rovinieta', name: 'about-erov', component: AboutErov },
    { path: '/despre-noi', name: 'about-us', component: AboutUs },
    { path: '/despre-peaj', name: 'about-peaj', component: AboutPeaj },
    { path: '/contact', name: 'contact', component: Contact },
    { path: '/intrebari-frecvente', name: 'questions', component: FrequentQuestions },
    { path: '/cookies', name: 'cookies', component: Cookies },

    { path: '/termeni-si-conditii', name: 'terms', component: Terms },
    { path: '/politica-de-confidentialitate', name: 'confidentiality', component: Confidentiality },

    { path: '/parteneri', name: 'partners', component: Partners },

    {
        path: '/comanda', component: OrderContainer,
        children: [
            { path: 'cos', name: 'cart', component: Cart },
            { path: 'facturare', name: 'billing', component: Billing, meta: {requiresAuth: false} },
            { path: 'modalitate-plata', name: 'payment-method', component: PaymentMethod, meta: {requiresAuth: false} },
        ]
    },
    { path: '/multumim', name: 'thank-you', component: ThankYou, meta: {requiresAuth: false} },

    {
        path: '/contul-meu', component: AccountContainer, meta: {requiresAuth: true},
        children: [
            { path: 'date-cont', name: 'account-data', component: AccountData, meta: {requiresAuth: true} },
            { path: 'masinile-mele', name: 'my-cars', component: MyCars, meta: {requiresAuth: true} },
            { path: 'comenzile-mele', name: 'my-orders', component: MyOrders, meta: {requiresAuth: true} },
            { path: 'profile', name: 'profiles', component: Profiles, meta: {requiresAuth: true} },
            { path: 'carduri', name: 'cards', component: Cards, meta: {requiresAuth: true} },
        ]
   },
   { path: '/comanda/:id/:type', name: 'order', component: Order, props: true, meta: {requiresAuth: true} },

   { path: '/cont/activare/:token', name: 'account-activate', props: true, component: AccountActivate },
   { path: '/adauga-masina', name: 'add-car', component: AddCar, meta: {requiresAuth: true} },
   { path: '/modifica-masina/:id', name: 'edit-car', component: EditCar, props: true, meta: {requiresAuth: true} },

   { path: '/adauga-profil', name: 'add-profile', component: AddProfile, props: true, meta: {requiresAuth: true} },
   { path: '/reset-parola', name: 'reset-password', component: ResetPassword },
   { path: '/reset-parola/:token', name: 'reset-password-update', component: ResetPasswordUpdate, props: true },
   { path: '/modifica-profil/:id', name: 'edit-profile', component: EditProfile, props: true, meta: {requiresAuth: true} },

   { path: '/avantaje-companii', name: 'company-advanges', component: BenefitsLadingPage, meta: {title: 'UNTRR'} }
];

export default routes;